<mat-nav-list [formGroup]="filterForm">
  <div class="profile-card">
    <div class="header">
      <span><img src="../../../assets/img/Logo - maknetic_white.png" /></span>
      <!-- <h2>{{(email)}}</h2> -->
    </div>
  </div>

  <div class="user-link-title" *ngIf="role=='superadmin' || role=='admin'">
    <span>{{ 'menu.admin_panel' | translate }}</span>
  </div>

  <div *ngIf="false && (role=='superadmin' || role=='admin')" class="print-select-container">
    <mat-form-field appearance="outline" class="print-select" style="width: 90%;">
      <mat-label>Selector impresora</mat-label>
      <mat-select>
        <mat-option value="1">
          Print 1
        </mat-option>
        <mat-option value="2">
          Print 2
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!--  <mat-divider></mat-divider>-->
  <!-- <a mat-list-item (click)="redirectTo('/users')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 0}">
    <mat-icon>account_circle</mat-icon>
    {{ 'menu.users' | translate }}
  </a> -->
  <div mat-list-item (click)="redirectTo('/users')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 0}" class="user-link">
    <span>{{ 'menu.users' | translate }}
      <!-- <mat-icon>account_circle</mat-icon> -->

    </span>

  </div>
  <!-- <a mat-list-item (click)="redirectTo('/templates')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 1}">
    <mat-icon>description</mat-icon>
    {{ 'menu.templates' | translate }}
  </a> -->

  <div mat-list-item (click)="redirectTo('/templates')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 1}" class="user-link">
    <span>
      {{ 'menu.templates' | translate }}
      <!-- <mat-icon>description</mat-icon> -->
    </span>

  </div>

  <!-- <a mat-list-item (click)="redirectTo('/yearperiods')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 2}">
    <mat-icon>event</mat-icon>
    {{ 'menu.yearperiods' | translate }}
  </a> -->

  <div mat-list-item (click)="redirectTo('/yearperiods')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 2}" class="user-link">
    <span>
      {{ 'menu.yearperiods' | translate }}
      <!-- <mat-icon>event</mat-icon> -->
    </span>

  </div>


  <!-- <a mat-list-item (click)="redirectTo('/products')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 4}">
    <mat-icon>sell</mat-icon>
    {{ 'menu.products' | translate }}
  </a> -->

  <div mat-list-item (click)="redirectTo('/products')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 4}" class="user-link">
    <span>
      {{ 'menu.products' | translate }}
      <!-- <mat-icon>sell</mat-icon> -->
    </span>

  </div>


  <!-- <a mat-list-item (click)="redirectTo('/catalogs')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 3}">
    <mat-icon>auto_stories</mat-icon>
    {{ 'menu.catalogs' | translate }}
  </a> -->

  <div mat-list-item (click)="redirectTo('/catalogs')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 3}" class="user-link">
    <span>
      {{ 'menu.catalogs' | translate }}
      <!-- <mat-icon>auto_stories</mat-icon> -->
    </span>

  </div>

  <!-- <a mat-list-item (click)="redirectTo('/schools')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 5}">
    <mat-icon>school</mat-icon>
    {{ 'menu.schools' | translate }}
  </a> -->

  <div mat-list-item (click)="redirectTo('/schools')" *ngIf="role=='superadmin' || role=='admin' || role=='school'"
    [ngClass]="{'active': activeRouteId.id == 5}" class="user-link">
    <span>
      {{ 'menu.schools' | translate }}
      <!-- <mat-icon>school</mat-icon> -->
    </span>

  </div>



  <!-- <a mat-list-item (click)="redirectTo('/studentphotos')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 6}">
    <mat-icon>image</mat-icon>
    {{ 'menu.students' | translate }}
  </a> -->
  <div mat-list-item (click)="redirectTo('/studentphotos')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 6}" class="user-link">
    <span>
      {{ 'menu.students' | translate }}
      <!-- <mat-icon>image</mat-icon> -->
    </span>

  </div>
  <div mat-list-item (click)="redirectTo('/orders-admin')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 10}" class="user-link">
    <span>
      {{ 'menu.orders-admin' | translate }}
      <!-- <mat-icon>fact_check</mat-icon> -->
    </span>

  </div>
  <div mat-list-item (click)="redirectTo('/reportages')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 13}" class="user-link">
    <span>
      {{ 'menu.reportages' | translate }}
    </span>
  </div>

  <div mat-list-item (click)="redirectTo('/reportage-details')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 15}" class="user-link">
    <span>
      {{ 'menu.reportages_photos' | translate }}
    </span>

  </div>
  <!-- <a mat-list-item (click)="redirectTo('/orders-admin')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 10}">
    <mat-icon>fact_check</mat-icon>
    {{ 'menu.orders-admin' | translate }}
  </a> -->

  

  <div mat-list-item (click)="redirectTo('/orders-reportages')" *ngIf="role=='superadmin' || role=='admin'"
    [ngClass]="{'active': activeRouteId.id == 14}" class="user-link">
    <span>
      {{ 'menu.orders-reportages' | translate }}
      <!-- <mat-icon>fact_check</mat-icon> -->
    </span>

  </div>

  <mat-divider *ngIf="role=='superadmin' || role=='admin'" style="border-top-width: 6px; border-top-color: white; margin: 8px 0;">
  </mat-divider>

  <!-- BELOW IS ALL USERS MENU ITEMS -->

  <!-- <a mat-list-item (click)="redirectTo('/welcome')" [ngClass]="{'active': activeRouteId.id == 11}" class="user-link">
    {{ 'menu.welcome' | translate }}
  </a> -->

  <div mat-list-item (click)="redirectTo('/welcome')" [ngClass]="{'active': activeRouteId.id == 11}" class="user-link">
    <span>{{ 'menu.welcome' | translate }}</span>
  </div>

  <div mat-list-item class="user-link" (click)="redirectTo('/how-it-works')"
    [ngClass]="{'active': activeRouteId.id == 12}">
    <span>{{'menu.how_it_works' | translate}}</span>
  </div>

  <div class="user-link-title">
    <span>{{ 'menu.photo_list' | translate }}</span>
  </div>

  <div *ngFor="let relationship of relationships">

    <div mat-list-item (click)="redirectTo('/student/'+relationship.id)"
      matTooltip="{{ 'buttons.student_photo_tooltip' | translate }}" matTooltipPosition="after"
      [ngClass]="{'active': activeRouteId.id == 8 && activeRouteId.student_id == relationship.id}"
      class="mat-list-item-student user-link">
      <span>{{ relationship.name }}</span>
    </div>

    <!-- <a mat-list-item (click)="redirectTo('/student/'+relationship.id)"
      matTooltip="{{ 'buttons.student_photo_tooltip' | translate }}" matTooltipPosition="after"
      [ngClass]="{'active': activeRouteId.id == 8 && activeRouteId.student_id == relationship.id}"
      class="mat-list-item-student user-link">
      <div class="student-link-text-box">
        <span>{{relationship.name}}</span> <span style="font-size: 12px;">{{relationship.yearperiod_name}}</span>
        <span>{{relationship.name}} {{relationship.yearperiod_name}}</span>
      </div>
    </a> -->
  </div>

  <div *ngFor="let reportage of reportages">

    <div mat-list-item (click)="redirectTo('/reportagephoto/'+reportage.id)"
      matTooltip="{{ 'buttons.student_photo_tooltip' | translate }}" matTooltipPosition="after"
      [ngClass]="{'active': activeRouteId.id == 8 && activeRouteId.reportage_id == reportage.id}"
      class="mat-list-item-student user-link">
      <span>{{ reportage.name }}</span>
    </div>
  </div>


  <div class="user-link-title">
    <span>{{ 'menu.management' | translate}}</span>
  </div>

  <div mat-list-item (click)=" redirectTo('/shopping-cart')" class="user-link" *ngIf="showOrderBtn">
    <span>{{ 'menu.order_in_progress' | translate }}</span>
  </div>

  <div mat-list-item (click)=" redirectTo('/orders')" [ngClass]="{'active': activeRouteId.id == 9}" class="user-link">
    <span>{{ 'menu.order_history' | translate }}</span>
  </div>

  <div mat-list-item class="user-email">
    <span>{{(email)}}</span>
  </div>

  <div mat-list-item (click)="logout()" class="user-logout">
    <span>
      <mat-icon style="margin: 0;">keyboard_arrow_left</mat-icon>{{ 'inputs.sign_out' | translate }}
    </span>
  </div>

  <!-- <a mat-list-item (click)=" redirectTo('/orders')" [ngClass]="{'active': activeRouteId.id == 9}" class="user-link">
    {{ 'menu.orders' | translate }}
  </a>
  <hr>
  <a mat-list-item (click)="logout()" class="user-link">
    {{ 'inputs.sign_out' | translate }}
  </a> -->

</mat-nav-list>